import * as t from 'io-ts';

/** Any layout item with a pose field */
export const WithPose = t.type({
    pose: t.type({
        position: t.type({
            x: t.number,
            y: t.number,
            z: t.number,
        }),
        orientation: t.type({
            w: t.number,
            x: t.number,
            y: t.number,
            z: t.number,
        }),
    }),
});

export type WithPose = t.TypeOf<typeof WithPose>;

function eqPosition(
    left: { x: number; y: number; z: number },
    right: { x: number; y: number; z: number },
): boolean {
    return left.x === right.x && left.y === right.y && left.z === right.z;
}

function eqOrientation(
    left: { w: number; x: number; y: number; z: number },
    right: { w: number; x: number; y: number; z: number },
): boolean {
    return left.w === right.w && eqPosition(left, right);
}

/**
 * Test the equality of two items with a pose component-wise
 */
export function eq(left: WithPose, right: WithPose): boolean {
    return (
        eqPosition(left.pose.position, right.pose.position) &&
        eqOrientation(left.pose.orientation, right.pose.orientation)
    );
}
